import { z } from 'zod/v3';

export const GitConfigSchema = z.object({
  repository: z.string(),
  branch: z.string(),
  path: z.string(),
  token: z.string(),
});
export type GitConfig = z.infer<typeof GitConfigSchema>;

export const AssetConfigSchema = z.object({
  baseUrl: z.string().optional(),
  strategy: z.enum(['reference', 'copy']),
  authentication: z.object({
    type: z.enum(['none', 'header', 'query']),
    credentials: z.record(z.string(), z.string()).optional(),
  }).optional(),
});
export type AssetConfig = z.infer<typeof AssetConfigSchema>;

export const PublishConfigSchema = z.object({
  platform: z.enum(['docusaurus', 'vitepress']),
  git: GitConfigSchema,
  assets: AssetConfigSchema,
});
export type PublishConfig = z.infer<typeof PublishConfigSchema>;

